// extracted by mini-css-extract-plugin
export default {"Stories":"Stories_Stories__HSEs+","main":"Stories_main__HqadM","form":"Stories_form__WxSn-","input":"Stories_input__6nqUT","dropdown":"Stories_dropdown__P1G-X"};